module.exports = __webpack_public_path__ + "static/media/Blorto_graphic.c8fa1dc5.png";